import { AnimatePresence, motion } from "framer-motion";
import OldMediaCard from "./OldMediaCard";
import { OldMediaItem } from "./types/oldMedia";

interface MediaViewProps {
  media: OldMediaItem[];
  handleView: (item: OldMediaItem) => void;
  grouped: {
    type: OldMediaItem["type"];
    label: string;
    items: OldMediaItem[];
  }[];
}

const OldMediaView = ({ handleView, grouped }: MediaViewProps) => {
  return (
    <div className="space-y-6">
      {/* Grouped by date */}
      <AnimatePresence>
        {grouped.map(({ type, label, items }) => (
          <motion.div key={type} layout>
            <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400 mb-3">
              {label} ({items.length})
            </p>
            <div className="grid grid-cols-5 gap-3">
              <AnimatePresence>
                {items.map((item) => (
                  <OldMediaCard
                    key={item.id}
                    item={item}
                    onView={() => handleView(item)}
                  />
                ))}
              </AnimatePresence>
            </div>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default OldMediaView